import { render, staticRenderFns } from "./IssuesSummaryCard.vue?vue&type=template&id=57df021c&scoped=true&"
import script from "./IssuesSummaryCard.vue?vue&type=script&lang=js&"
export * from "./IssuesSummaryCard.vue?vue&type=script&lang=js&"
import style0 from "./IssuesSummaryCard.vue?vue&type=style&index=0&id=57df021c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57df021c",
  null
  
)

export default component.exports